export interface Category {
  slug: string
  name: string
  description: string
  icon: string
  count: number
  colorClass: string
}

export const categories: Category[] = [
  {
    slug: 'hot',
    name: '热门推荐',
    description: '当前最受欢迎的色里番作品，根据用户观看量和评分综合排序，持续更新热门榜单。',
    icon: 'ri-fire-line',
    count: 128,
    colorClass: 'bg-primary-500',
  },
  {
    slug: 'new',
    name: '新番速递',
    description: '最新上线的色里番作品，包括当季新番和即将上映的预告信息，快人一步发现新作。',
    icon: 'ri-rocket-line',
    count: 56,
    colorClass: 'bg-accent-500',
  },
  {
    slug: 'classic',
    name: '经典回顾',
    description: '历久弥新的经典色里番作品，经过时间考验的优质内容，值得反复品味的传世之作。',
    icon: 'ri-vip-crown-line',
    count: 89,
    colorClass: 'bg-secondary-500',
  },
  {
    slug: 'ranking',
    name: '排行榜',
    description: '综合评分最高的色里番作品排行，涵盖月度、季度和年度榜单，发现口碑佳作。',
    icon: 'ri-bar-chart-line',
    count: 50,
    colorClass: 'bg-primary-600',
  },
  {
    slug: 'collection',
    name: '精选合集',
    description: '按主题整理的色里番合集推荐，包括系列作品、同作者作品等精选内容汇总。',
    icon: 'ri-folder-3-line',
    count: 72,
    colorClass: 'bg-accent-600',
  },
  {
    slug: 'genre',
    name: '类型分类',
    description: '按题材类型细分的色里番作品，方便您根据喜好精准定位感兴趣的内容类型。',
    icon: 'ri-price-tag-3-line',
    count: 156,
    colorClass: 'bg-secondary-600',
  },
]